export default __webpack_public_path__ + "static/media/apple.f41c5456.svg";